<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
        <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='18'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加订单</el-button>
            <el-button v-if="current_user.id == 2 || current_user.id == 100" type="primary" size="mini" round plain @click="Uploadorder('1')" icon="el-icon-upload2">订单EXCEl上传</el-button>
            <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">出库订单导出</el-button>
            <el-button type="success" size="mini" round plain @click="Export1()" icon="el-icon-download">订单导出</el-button>
            <el-select style="margin-left: 5px;" v-model="userIdList" size="mini" placeholder="请选择业务员" multiple clearable>
              <el-option
                v-for="item in optionsUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" size="mini" @click="BatchUser">确定分配订单</el-button>
            <el-button v-if="current_user.id == 2 || current_user.id == 100" type="primary" size="mini" round plain @click="Uploadorder('2')" icon="el-icon-caret-top">入库订单导入</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <div class="cght_ddgltop" style="margin-bottom: 10px;border: 1px solid #DCDFE6;border-radius: 4px">
              <ul class="cght_ddglnavula">
                <li>
                  <a href="javascript:;" :class="{cght_busorder:listQuery.is_complete == null}" @click="changeComplete()">全部订单</a>
                </li>
                <li>
                  <a href="javascript:;" :class="{cght_busorder:listQuery.is_complete == '1'}" @click="changeComplete('1')">已下单</a>
                </li>
                <li>
                  <a href="javascript:;" :class="{cght_busorder:listQuery.is_complete == '2'}" @click="changeComplete('2')">已发货</a>
                </li>
                <li>
                  <a href="javascript:;" :class="{cght_busorder:listQuery.is_complete == '3'}" @click="changeComplete('3')">已入库</a>
                </li>
                <li>
                  <a href="javascript:;" :class="{cght_busorder:listQuery.is_complete == '4'}" @click="changeComplete('4')">订单删除</a>
                </li>
              </ul>
            </div>
            <!--右边内容区域开始-->
            <el-row style="margin-bottom: 10px">
              <el-col :span="7">
                <el-date-picker
                  v-model="listQuery.addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="searchUser"
                  size="small"
                  style="width: 363px">
                </el-date-picker>
              </el-col>
              <el-col :span="12">
                <el-cascader v-model="listQuery.factory_code" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name'}"  style="width: 100%;padding-left: 15px;" placeholder="请选择工厂" @change="searchUser" size="small"></el-cascader>
              </el-col>
              <el-col :span="4" style="margin-left: 30px">
                <el-select v-model="listQuery.is_complete" clearable placeholder="订单状态" size="small" @change="searchUser">
                  <el-option label="已下单" value="1"></el-option>
                  <el-option label="已发货" value="2"></el-option>
                  <el-option label="已入库" value="3"></el-option>
                  <el-option label="订单删除" value="4"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="4">
                <el-input size="small" v-model="listQuery.tracking_num" clearable placeholder="请输入申购人" style="width: 220px">
                </el-input>
              </el-col> -->
              <el-col :span="7">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="采购订单号、物料编码、物料描述、申购人" class="filter-item">
                  <el-button slot="append" @click="searchUser">搜索</el-button>
                </el-input>
              </el-col>
              <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="4" style="margin-left: 15px">
                <el-select v-model="listQuery.user_id" placeholder="请选择业务员" clearable @change="searchUser" size="small">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="liststyle" :span="4" style="float: right">
                <span class="smalltut" :class="{on:listMode=='list'}"><a href="javascript:;"  @click="SwitchMode('list')">列表</a></span>
                <span class="bigtut" :class="{on:listMode=='card'}"><a href="javascript:;" @click="SwitchMode('card')">大图</a></span>
              </el-col>
            </el-row>
            <el-row v-if="listMode=='list'" style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <div ref="topScroll" class="top-scroll" @scroll="handleScrollTop">
                  <div class="top-scroll-content" :style="tableWidth"></div>
                </div>
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" prop="addtime" label="日期" sortable width="100"></el-table-column>
                  <el-table-column align="center" label="工厂名称（编码）" width="150">
                    <template slot-scope="{row}">
                      <span>{{ row.factory_name + '（' + row.factory_code + '）' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="purchase_order_num" label="采购订单号" width="110"></el-table-column>
                  <el-table-column align="center" prop="material_code" label="物料编码" width="105"></el-table-column>
                  <el-table-column align="center" prop="material_des" label="物料描述" width="210"></el-table-column>
                  <el-table-column align="center" label="数量" width="55">
                    <template slot-scope="{row}">
                      <span>{{ row.number }}</span><br/>
                      <span v-if="row.w_number" :class="row.number==row.w_number ? 'num-y-color':'num-n-color'">({{ row.w_number }})</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="units" label="单位" width="50"></el-table-column>
                  <el-table-column align="center" prop="tax_price" label="单价" width="70"></el-table-column>
                  <el-table-column align="center" label="总价">
                    <template slot-scope="{row}">
                      <span>{{ row.total_price }}</span><br/>
                      <span v-if="row.w_total_price" style="color: #13ce66;">({{ row.w_total_price }})</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="tracking_num" label="申购人" width="110"></el-table-column>
                  <el-table-column label="订单状态" align="center" width="120">
                    <template slot-scope="{row}">
                      <!-- <el-switch
                        v-model="row.is_complete"
                        active-value="2"
                        active-text="是"
                        active-color="#13ce66"
                        inactive-text="否"
                        inactive-value="1"
                        inactive-color="#ff4949"
                        @change="changeIscomplete(row, 'is_complete')"
                      >
                      </el-switch> -->
                      <el-select v-model="row.is_complete" placeholder="请选择" @change="changeIscomplete(row, 'is_complete')" :class="row.is_complete=='3' ? 'custom-select-color':''">
                        <el-option label="已下单" value="1"></el-option>
                        <el-option label="已发货" value="2"></el-option>
                        <el-option label="已入库" value="3"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="订单分配" width="150">
                    <template slot-scope="{row}">
                      <el-select v-model="row.user_id" placeholder="请选择" multiple clearable @change="changUser(row)">
                        <el-option
                          v-for="item in optionsUserList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="50"></el-table-column>
                  <!-- <el-table-column align="center" prop="id" label="序号"></el-table-column> -->
                  <el-table-column align="center" prop="order_num" label="序号" width="50"></el-table-column>
                  <el-table-column align="center" prop="delivery_location" label="收货库存地点" width="105"></el-table-column>
                  <el-table-column align="center" label="物流单号" width="150px">
                    <template slot-scope="scope">
                        <span @click="checkLogistics(scope.row)" style="cursor: pointer; color: cornflowerblue;">{{ scope.row.tracking_number }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right" width="90">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该订单吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getBusinessOrdersList" :pageSizes="[10, 20, 30, 40, 50]"/>
              </el-col>
            </el-row>
            <el-row v-if="listMode=='card'" style="position: static;">
              <div v-for="(item, index) in list" :key="index" style="position: static;">
                <div>
                  <table class="cght_ddtable_busord" width="100%" cellspacing="0" cellpadding="0">
                    <tr class="cght_ddtabletb_busord">
                      <td colspan="8">
                        <div class="cght_ddtablesj_busord" style="width: 7px;">
                          <el-checkbox v-model="item.checkType" @change="handleCheckedAll(index)" size="medium" :disabled="!item.open"></el-checkbox>
                        </div>
                        <div class="cght_ddtablesj_busord" @click="OpenBusOrd(item, index, '1')" style="width: 15%;font-weight: bold;cursor: pointer;">
                          {{item.time}} <i v-if="item.open" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i>
                        </div>
                        <div class="cght_ddtableddh_busord" style="width: 15%;">订单详情</div>
                        <div v-if="item.open" class="cght_ddtableddh_busord">
                          <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                            <span class="el-dropdown-link">
                              {{ ChangeFactory ? ChangeFactory : '选择工厂' }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item v-for="(items, indexs) in FactoryList" :key="indexs" :command="{item,items,index}">{{ items.factory_name }}</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <table v-show="item.open" class="cght_ddtable_busord" v-for="(items, indexs) in listChildren" :key="indexs" width="100%" cellspacing="0" cellpadding="0">
                  <tr class="cght_ddtabletb_busord">
                    <td colspan="8">
                      <div class="cght_ddtablesj_busord" style="width: 13%;">
                        <el-checkbox v-model="items.checkType" @change="handleCheckedCitiesChange()" size="medium"></el-checkbox> {{items.addtime}}
                      </div>
                      <div class="cght_ddtableddh_busord" style="width: 17%;">采购订单号：<em>{{items.purchase_order_num}}</em></div>
                      <div class="cght_ddtablesl_busord" style="width: 11%;">数量</div>
                      <div class="cght_ddtablesl_busord" style="width: 100px">单价</div>
                      <div class="cght_ddtablesl_busord" style="width: 100px">工厂名称</div>
                      <div class="cght_ddtablesl_busord" style="width: 100px">总价</div>
                      <div class="cght_ddtablesl_busord" style="width: 110px">备注</div>
                      <div class="cght_ddtablesl_busord" style="width: 100px">收货库存地点</div>
                      <el-popover
                        :ref="'popover-' + indexs"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该订单吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="PopoverClose(indexs)">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(items,indexs)">确定</el-button>
                        </div>
                        <div class="cght_ddtablesc_busord" slot="reference"><i class="iconfont cght_scddqdshowtc">&#xe611;</i></div>
                      </el-popover>
                      <div class="cght_ddtablesc_busord" style="color:#409EFF;cursor: pointer;" @click="handleEdit(indexs, items)">订单编辑</div>
                    </td>
                  </tr>
                  <tr>
                    <td width="40%" class="cght_ddtablexxnrabox_busord">
                      <div class="cght_ddtablexxnra_busord">
                        <router-link v-if="items.goods_id" :to="{path:'/GoodsDetail',query:{id:items.goods_id}}" target="_blank">
                          <img v-real-img="items.imgpath" src="../../assets/images/zwtp.jpg" :alt="items.title" width="80" height="80" />
                        </router-link>
                        <img v-else v-real-img="items.imgpath" src="../../assets/images/zwtp.jpg" :alt="items.title" width="80" height="80" />
                      </div>
                      <div class="cght_ddtablexxnrb_busord">
                        <h2 v-if="items.goods_id">
                          <router-link :to="{path:'/GoodsDetail',query:{id:items.goods_id}}" target="_blank">{{items.material_des}}</router-link>
                        </h2>
                        <h2 v-else>
                          {{items.material_des}}
                        </h2>
                        <h3>
                          {{items.material_code}}
                        </h3>
                      </div>
                      <div class="cght_ddtablexxnrc_busord">x{{items.number}}</div>
                    </td>
                    <td width="8%" class="cght_ddtableshrm_busord">
                      <div class="cght_ddtableje4_busord">￥{{items.tax_price}} /{{items.units}}</div>
                    </td>
                    <td width="8%" class="cght_ddtableshrm_busord">{{ items.factory_name }}<br/>{{ items.factory_code }}</td>
                    <td width="8%">
                      <div class="cght_ddtableje5_busord" v-if="items.tax_price && items.tax_price > 0">￥{{(items.tax_price*items.number).toFixed(2)}}</div>
                    </td>
                    <td width="8%" class="cght_ddtableshrm_busord">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:500px" v-if="items.remarks" class="set-popper">{{ items.remarks }}
                            <el-link v-if="getUrl(items.remarks)" :href="getUrl(items.remarks)" type="primary" target="_blank">前往</el-link>
                          </div>
                        </template>
                        <div v-if="items.remarks && items.remarks.length > 50" slot="reference" class="set-content">
                          {{ items.remarks ? items.remarks.substring(0, 50) + '...': '' }}
                        </div>
                        <div v-else slot="reference" class="set-content">
                          {{ items.remarks }}
                        </div>
                      </el-popover>
                    </td>
                    <td width="8%" class="cght_ddtableshrm_busord">{{ items.delivery_location }}</td>
                    <td width="8%">
                      <div class="cght_ddtablelast2_busord">
                        <div class="cght_ddtablelast3_busord">
                          <el-select v-model="items.is_complete" placeholder="请选择" @change="changeIscomplete(items, 'is_complete')" :class="items.is_complete=='3' ? 'custom-select-color':''" size="small" style="width: 86px;margin-top: 44px">
                            <el-option label="已下单" value="1"></el-option>
                            <el-option label="已发货" value="2"></el-option>
                            <el-option label="已入库" value="3"></el-option>
                          </el-select>
                        </div>
                        <div v-if="items.tracking_number" @click="checkLogistics(items)" class="cght_ddtablelast3_busord" style="color:#409EFF;cursor:pointer;font-size:14px">查看物流</div>
                      </div>
                    </td>
                    <td width="8%">
                      <div class="cght_ddtablelast2_busord">
                        <div class="cght_ddtablelast3_busord">
                          <el-select v-model="items.user_id" placeholder="请选择" multiple clearable @change="changUser(items)" size="small" style="width:86px;margin-top: 44px">
                            <el-option
                              v-for="item in optionsUserList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </div>
                        <el-popover placement="top" trigger="hover">
                          <template>
                            <div v-if="items.remarks" class="set-popper">{{ items.remarks }}
                              <el-link v-if="getUrl(items.remarks)" :href="getUrl(items.remarks)" type="primary" target="_blank">前往</el-link>
                            </div>
                          </template>
                          <div v-if="items.remarks" slot="reference" class="cght_ddtablelast3_busord" style="color:#409EFF;cursor:pointer;font-size:14px;width:50px;margin:0 auto;">备注</div>
                        </el-popover>
                      </div>
                    </td>
                  </tr>
                </table>
                <pagination v-show="listChildrenTotal>0 && item.open" :total="listChildrenTotal" :page.sync="listQueryCh.page" :limit.sync="listQueryCh.limit" @pagination="OpenBusOrd(item, index, '2')" :pageSizes="[10, 20, 30, 40, 50]" style="border-bottom: 1px solid #efefef;border-left: 1px solid #efefef;border-right: 1px solid #efefef;" />
              </div>
              <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getBusinessOrdersList" :pageSizes="[10, 20, 30, 40, 50]"/>
              <div class="cght_cnxhtiwtjsp" v-if="list.length === 0">
                <div>
                  <em class="myemptydata">暂无数据</em>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="订单编辑" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div v-loading="qyloading">
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">订单详情</div>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="采购订单号" prop="purchase_order_num" label-width="140px">
                  <el-input v-model="formData.purchase_order_num" placeholder="请输入采购订单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工厂名称" prop="factory_name" label-width="140px">
                  <el-input v-model="formData.factory_name" placeholder="请输入工厂名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="收货库存地点" prop="delivery_location" label-width="140px">
                  <el-input v-model="formData.delivery_location" placeholder="请输入收货库存地点"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采购订单创建日期" label-width="140px">
                  <el-date-picker
                    v-model="formData.addtime"
                    type="date"
                    placeholder="请选择采购订单创建日期"
                    :clearable="false"
                    style="width:100%"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">商品信息</div>
                <div class="ant-card-head-button">
                  <el-button v-if="formData.filename" slot="trigger" type="primary" icon="el-icon-download" style="margin:0px 6px 6px 20px;float:left;" @click="DownQuotation(formData.filename)">订单EXCEl下载</el-button>
                  <el-popover v-model="visible" placement="top" width="200px" style="margin:0px 6px 6px 20px;float:left;">
                    <p>确定清空吗？</p>
                    <div style="text-align: right; margin: 0;">
                      <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="ClearGoodsMessage">确定</el-button>
                    </div>
                    <el-button slot="reference" icon="el-icon-delete">清空表单</el-button>
                  </el-popover>
                  <div class="filter-container">
                    <el-input v-model="SearchData" placeholder="请输入序号" style="width: 200px;padding-bottom:4px" class="filter-item" />
                    <el-button class="filter-item" type="primary" icon="el-icon-search" @click="goNum">搜索</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item,index) in goodsMessage" :key="index" class="ant-card-bottom">
              <el-form :ref="'item'+index" :model="item" :rules="rules" style="padding-bottom: 0;" label-position="top">
                <el-row :class="'goNum_'+item.order_num">
                  <el-col :span="1">
                    <el-form-item label="序号" prop="order_num">
                      <div style="width: 30px;height: 30px;font-size: 15px;">{{ item.order_num }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" style="margin-left: 10px;">
                    <el-form-item label="物料编码" prop="material_code">
                      <el-autocomplete
                        v-model="item.material_code"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入物料编码"
                        :title="item.material_code"
                        clearable
                        style="width:100%"
                        @select="handleSelect($event, index)"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" style="margin-left: 5px;">
                    <el-form-item label="物料描述" prop="material_des">
                      <el-input v-model="item.material_des" placeholder="请输入物料描述" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="数量" prop="number">
                      <el-input v-model="item.number" placeholder="请输入数量" min="1" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="单位" prop="units">
                      <el-input v-model="item.units" placeholder="单位" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="单价" prop="tax_price">
                      <el-input v-model="item.tax_price" placeholder="单价" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" style="margin-left: 5px;">
                    <el-form-item label="申购人">
                      <el-input v-model="item.tracking_num" placeholder="申购人" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5" style="margin-left: 65px;">
                    <el-form-item label="快递选择">
                      <el-select v-model="item.logistics" placeholder="请选择快递" clearable style="width:100%">
                        <el-option v-for="(items,index) in gridData" :key="index" :label="items.label" :value="items.value"></el-option>
                      </el-select>
                      <el-link v-if="goodsMessage.length > 1" type="primary" @click="delMsg(index)">删除</el-link>&nbsp;
                      <el-link type="primary" @click="addMsg">添加</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 5px;">
                    <el-form-item label="物流单号">
                      <el-input v-model="item.tracking_number" placeholder="请输入物流单号"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 5px;">
                    <el-form-item label="备注">
                      <el-input v-model="item.remarks" placeholder="请输入备注" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-left: 5px;">
                    <el-form-item label="链接来源">
                      <el-input v-model="item.url" placeholder="请输入链接来源" clearable>
                        <el-button slot="append" @click="copyText(item.url)">复制</el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBusinessOrders()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单EXCEl上传" :visible.sync="dialogOrderVisible" width="20%">
      <el-form :model="formOrderData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="模板类型" prop="templateType">
              <el-select v-model="formOrderData.templateType" clearable placeholder="请选择模板类型" size="small">
                <el-option label="蒙牛" value="1"></el-option>
                <el-option label="内蒙大窑" value="2"></el-option>
                <el-option label="齐鲁制药" value="3"></el-option>
                <el-option label="阜丰生物" value="4"></el-option>
                <el-option label="正大饲料" value="5"></el-option>
                <el-option label="蒙牛MRO" value="6"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="上传文件" prop="filename">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1">
                <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="importBusOrder()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单管理说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="isShow" width="700px">
      <div style="padding-bottom:15px;font-size:15px">
        <span>
          {{ expName }}：
        </span>
        <span>
          {{ expNumber }}
        </span>
      </div>
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color= '#fe722c'
          :timestamp="activity.time">
          {{activity.status}}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/businessOrders'
import expense from '@/api/expense'
import workdiary from '@/api/workdiary'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'BusinessOrders',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_business_orders',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      formData: {
        id: null,
        purchase_order_num: '',
        factory_name: '',
        delivery_location: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      },
      formOrderData: {
        templateType: '',
        filename: '',
        importType: ''
      },
      goodsMessage: [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1,
          user_id: null,
          logistics: '',
          tracking_number: ''
        }
      ], // 货品信息
      rules: {
        purchase_order_num: [{ required: true, message: '请输入采购订单号', trigger: 'blur' }],
        factory_name: [{ required: true, message: '请输入工厂名称', trigger: 'blur' }],
        delivery_location: [{ required: true, message: '请输入收货库存地点', trigger: 'blur' }],
        material_code: [{ required: true, message: '请输入物料编码', trigger: 'blur' }],
        material_des: [{ required: true, message: '请输入物料描述', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        tax_price: [{ required: true, message: '请输入单价', trigger: 'blur' }]
      }, // 上传订单
      ruless: {
        templateType: [{ required: true, message: '请选择模板类型', trigger: 'blur' }],
        filename: [{ required: true, message: '请上传模板文件', trigger: 'change' }]
      },
      visible: false,
      SearchData: '',
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      optionsUserList: [],
      userIdList: [],
      primary_key: 'business_orders_goods_id',
      primary_keys: 'id',
      noTime: [],
      pickerOptions: this.customDateStyle(),
      companyList: [],
      tableWidth: {
        width: 0
      },
      reverse: true,
      activities: [],
      isShow: false,
      gridData: [
        {
          label: '德邦快递',
          value: 'DBL'
        },
        {
          label: '顺丰速运',
          value: 'SF'
        },
        {
          label: '京东',
          value: 'JD'
        },
        {
          label: '百世快递',
          value: 'HTKY'
        },
        {
          label: '中通快递',
          value: 'ZTO'
        },
        {
          label: '申通快递',
          value: 'STO'
        },
        {
          label: '圆通速递',
          value: 'YTO'
        },
        {
          label: '韵达速递',
          value: 'YD'
        },
        {
          label: '邮政快递包裹',
          value: 'YZPY'
        },
        {
          label: 'EMS',
          value: 'EMS'
        },
        {
          label: '天天快递',
          value: 'HHTT'
        },
        {
          label: '优速快递',
          value: 'UC'
        },
        {
          label: '宅急送',
          value: 'ZJS'
        },
        {
          label: '顺心捷达',
          value: 'SXJD'
        },
        {
          label: '安能',
          value: 'ANE'
        },
        {
          label: '其他',
          value: 'qts'
        }
      ],
      listMode: 'card',
      checkedArr: {
        id: [],
        business_orders_goods_id: []
      },
      expName: '',
      expNumber: '',
      listChildren: [],
      listChildrenTotal: 0,
      listQueryCh: {
        limit: 10,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      ChangeFactory: '',
      FactoryList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getUserList()
    this.getBusinessOrdersList()
    this.filterDate()
    this.getCompanyList()
  },
  methods: {
    getUserList () {
      api.getUserList({MAccountRole: '1, 5, 7'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    getBusinessOrdersList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100 || this.current_user.id === 69) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      if (this.listMode === 'list') {
        api.getBusinessOrdersList(this.listQuery).then(response => {
          this.list = response.data.items
          this.total = response.data.total
          this.isLoading = false
          this.qyloading = false
          this.TableScrollTop()
        })
      } else if (this.listMode === 'card') {
        api.getBusinessOrdersListCard(this.listQuery).then(response => {
          this.list = response.data.items
          this.total = response.data.total
          this.isLoading = false
          this.qyloading = false
        })
      }
    },
    filterDate () {
      api.filterDate({user_id: this.current_user.id}).then(response => {
        if (response.code === 20000) {
          this.noTime = response.data
        } else {
          this.noTime = []
        }
      })
    },
    getCompanyList () {
      expense.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    importBusOrder () {
      this.$refs['FormOrder'].validate((valid) => {
        if (valid) {
          api.importBusOrder(this.formOrderData).then((response) => {
            if (response.code === 20000) {
              this.$notify({
                title: '成功',
                message: response.message,
                type: 'success'
              })
              this.dialogOrderVisible = false
              this.getBusinessOrdersList()
            }
          })
        }
      })
    },
    changeIscomplete (row, fieldName) {
      const params = { id: row.business_orders_goods_id }
      params[fieldName] = row[fieldName]
      api.changeIscomplete(params).then(res => {
        if (res.code === 20000) {
          this.filterDate()
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },
    DownQuotation (e) {
      window.open(e)
    },
    addMsg (index) {
      // if (this.goodsMessage.length + 1 > 10) {
      //   return
      // }
      var num = this.goodsMessage.length - 1
      this.goodsMessage.push({
        order_num: this.goodsMessage[num].order_num + 1,
        material_code: '',
        material_des: '',
        number: 1,
        units: '',
        tax_price: '',
        tracking_num: '',
        is_delete: 1,
        user_id: this.current_user.id,
        logistics: '',
        tracking_number: ''
      })
    },
    delMsg (index) {
      var numold = this.goodsMessage[0].order_num
      this.goodsMessage.splice(index, 1)
      var numnew = this.goodsMessage[0].order_num
      // 重新排序
      for (var i = index; i < this.goodsMessage.length; i++) {
        if (index === 0) {
          this.goodsMessage[i].order_num = i + numold
        } else {
          this.goodsMessage[i].order_num = i + numnew
        }
      }
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        purchase_order_num: '',
        factory_name: '',
        delivery_location: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      }
      this.goodsMessage = [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1,
          user_id: this.current_user.id,
          logistics: '',
          tracking_number: ''
        }
      ]
    },
    Uploadorder (value) {
      this.formOrderData.templateType = ''
      this.formOrderData.filename = ''
      this.fileList = []
      this.formOrderData.importType = value
      this.dialogOrderVisible = true
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      // this.formData = Object.assign({}, row)
      // this.goodsMessage = row.goodsMessage
      api.getDetail({ id: row.id }).then(response => {
        if (response.code === 20000) {
          this.formData = response.items
          this.goodsMessage = response.items.goodsMessage
        } else {
          this.$message.error(response.message)
        }
      })
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    handleDelete (row, index) {
      api.handleDelete({ id: row.business_orders_goods_id }).then(response => {
        this.getBusinessOrdersList()
        if (this.listMode === 'list') {
          this.$refs['popover-' + index].doClose()
        } else if (this.listMode === 'card') {
          this.$refs['popover-' + index][0].doClose()
        }
      })
    },
    querySearchAsync (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurants = [{ value: '暂无匹配信息' }]
        cb(this.restaurants)
      } else {
        if (queryString) {
          api.searchGoods({ 'search': queryString }).then(response => {
            this.restaurants = response.items
            // const findout = this.restaurants.filter((x) => this.nameFilter(x, queryString))
            results = this.restaurants.map(x => ({ ...x, value: x.title }))
            if (results.length > 0) {
              clearTimeout(this.timeout)
              this.timeout = setTimeout(() => {
                cb(results)
              }, 1000 * Math.random())
            } else {
              const nodata = [{ value: '暂无匹配信息' }]
              cb(nodata)
            }
          })
        }
      }
    },
    handleSelect (item, index) {
      this.goodsMessage[index].material_code = item.mengniu_code
      this.goodsMessage[index].material_des = item.title
      this.goodsMessage[index].units = item.units
      this.goodsMessage[index].tax_price = item.tax_price
    },
    ClearGoodsMessage () {
      this.goodsMessage = [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1,
          user_id: this.current_user.id,
          logistics: '',
          tracking_number: ''
        }
      ]
      this.visible = false
    },
    goNum () {
      this.$el.querySelector('.goNum_' + this.SearchData).scrollIntoView({ block: 'start', behavior: 'smooth' })
      document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.add('highlight')
      setTimeout(() => {
        document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.remove('highlight')
      }, 5000)
    },
    saveBusinessOrders () {
      const This = this
      this.goodsMessage.forEach((item, index) => {
        // 有多个输入框需校验，待都校验成功后再进行别的操作，所以需要使用Promise
        // 划重点：This.$refs['item'+index][0]
        This.$refs['item' + index][0].validate((valid) => {
          if (valid) {
          }
        })
      })
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          this.formData.goodsMessage = this.goodsMessage
          // this.formData.user_id = this.current_user.id
          api.saveBusinessOrders(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            // this.getBusinessOrdersList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    changUser (row) {
      const params = { id: row.business_orders_goods_id, order_id: row.id }
      params['user_id'] = row.user_id
      api.changUser(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '分配成功', type: 'success' })
        } else {
          this.$message({ message: '分配失败', type: 'error' })
        }
      })
    },
    searchUser () {
      this.listQuery.page = 1
      this.getBusinessOrdersList()
    },
    // 批量修改分配
    BatchUser () {
      var ids = []
      var orderIds = []
      if (this.listMode === 'list') {
        if (this.$refs.singleTable.selection.length > 0) {
          if (this.userIdList.length === 0) {
            this.$message({ message: '请选择业务员', type: 'error' })
            return
          }
          ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
          orderIds = this.$refs.singleTable.selection.map(a => a[this.primary_keys])
          api.changUser({id: ids, user_id: this.userIdList, order_id: orderIds}).then(response => {
            if (response.code === 20000) {
              this.$message({ message: '操作成功', type: 'success' })
              this.getBusinessOrdersList() // 重新加载数据
            } else {
              this.$message({ message: '操作失败', type: 'error' })
            }
          })
        } else {
          this.$message({ message: '请选择分配的数据', type: 'error' })
        }
      } else if (this.listMode === 'card') {
        if (this.checkedArr.business_orders_goods_id.length > 0) {
          ids = this.checkedArr.business_orders_goods_id
          orderIds = this.checkedArr.id
          api.changUser({id: ids, user_id: this.userIdList, order_id: orderIds}).then(response => {
            if (response.code === 20000) {
              this.$message({ message: '操作成功', type: 'success' })
              this.getBusinessOrdersList() // 重新加载数据
            } else {
              this.$message({ message: '操作失败', type: 'error' })
            }
          })
        } else {
          this.$message({ message: '请选择要导出的数据', type: 'error' })
        }
      }
    },
    // 批量导出
    Export () {
      var ids = []
      if (this.listMode === 'list') {
        if (this.$refs.singleTable.selection.length > 0) {
          ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
          api.export({id: ids}).then(response => {
            if (response.code === 20000) {
              window.open(response.savename)
            } else if (response.code === 30000) {
              this.$message.error(response.message)
            } else {
              this.$message.error('导出错误')
            }
          })
        } else {
          this.$message({ message: '请选择要导出的数据', type: 'error' })
        }
      } else if (this.listMode === 'card') {
        if (this.checkedArr.business_orders_goods_id.length > 0) {
          ids = this.checkedArr.business_orders_goods_id
          api.export({id: ids}).then(response => {
            if (response.code === 20000) {
              window.open(response.savename)
            } else if (response.code === 30000) {
              this.$message.error(response.message)
            } else {
              this.$message.error('导出错误')
            }
          })
        } else {
          this.$message({ message: '请选择要导出的数据', type: 'error' })
        }
      }
    },
    Export1 () {
      if (this.listQuery.addtimeBTTime && this.listQuery.addtimeBTTime.length > 0) {
        api.export1({listQuery: this.listQuery}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择导出时间再导出数据', type: 'error' })
      }
    },
    customDateStyle () {
      let self = this
      return {
        cellClassName (time) {
          let day = time.getDate()
          if (day < 10) {
            day = '0' + day
          };
          let month = time.getMonth() + 1
          if (month < 10) {
            month = '0' + month
          };
          let year = time.getFullYear()
          let res = year + '-' + month + '-' + day
          for (let i = 0; i < self.noTime.length; i++) {
            let _time = self.noTime[i]
            if (res === _time) {
              return 'noColor'
            }
          }
        },
        disabledDate(time) {
          // 例如，只允许选择2023年1月1日之前的日期
          return time.getTime() > new Date('2025-09-30').getTime();
        }
      }
    },
    // 顶部滚动条
    handleScrollTop () {
      if (this.$refs.topScroll) {
        let scrollLeft = this.$refs.topScroll.scrollLeft
        this.$refs.singleTable.bodyWrapper.scrollTo(scrollLeft, 0)
      }
    },
    TableScrollTop () {
      setTimeout(() => {
        if (this.$refs.singleTable) {
          this.tableWidth.width = this.$refs.singleTable.bodyWrapper.scrollWidth + 'px'
          this.$refs.singleTable.doLayout()
          // 此代码为监听表格滚动条的事件：
          this.tableDom = this.$refs.singleTable.bodyWrapper
          this.tableDom.addEventListener('scroll', () => {
            // 滚动距离
            let scrollLeft = this.tableDom.scrollLeft
            this.$refs.topScroll.scrollTo(scrollLeft, 0)
          })
        }
      }, 500)
    },
    checkLogistics (row) {
      this.activities = []
      this.isShow = true
      workdiary.checkLogistics({ com: row.logistics, nu: row.tracking_number, tel: '' }).then(res => {
        if (res.item.status === '0') {
          this.expName = res.item.result.expName
          this.expNumber = res.item.result.number
          this.activities = res.item.result.list.reverse()
        } else {
          this.$message.error(res.item.msg)
        }
      })
    },
    handleCheckedCitiesChange () {
      this.checkedArr.id = []
      this.checkedArr.business_orders_goods_id = []
      for (var i = 0; i < this.listChildren.length; i++) {
        if (this.listChildren[i].checkType) {
          this.checkedArr.id.push(this.listChildren[i]['id'])
          this.checkedArr.business_orders_goods_id.push(this.listChildren[i]['business_orders_goods_id'])
        }
      }
    },
    handleCheckedAll (index) {
      this.checkedArr.id = []
      this.checkedArr.business_orders_goods_id = []
      for (var i = 0; i < this.listChildren.length; i++) {
        this.listChildren[i].checkType = this.list[index].checkType
        if (this.listChildren[i].checkType) {
          this.checkedArr.id.push(this.listChildren[i]['id'])
          this.checkedArr.business_orders_goods_id.push(this.listChildren[i]['business_orders_goods_id'])
        }
      }
    },
    PopoverClose (index) {
      this.$refs['popover-' + index][0].doClose()
    },
    SwitchMode (listMode) {
      this.listMode = listMode
      this.getBusinessOrdersList()
    },
    OpenBusOrd (item, index, num) {
      if (num === '1') {
        for (var i = 0; i < this.list.length; i++) {
          if (index !== i) {
            this.list[i].open = false
          }
        }
        this.listQueryCh.page = 1
        this.listQueryCh.factory_codes = null
        this.ChangeFactory = ''
        this.list[index].open = !this.list[index].open
      }
      this.listChildren = []
      this.listQueryCh.addtimeBTTime = [item.time, item.time]
      this.listQueryCh.factory_code = this.listQuery.factory_code ? this.listQuery.factory_code : null
      this.listQueryCh.is_complete = this.listQuery.is_complete ? this.listQuery.is_complete : null
      this.listQueryCh.search = this.listQuery.search ? this.listQuery.search : null
      this.listQueryCh.user_id = this.listQuery.user_id ? this.listQuery.user_id : null
      api.getBusinessOrdersList(this.listQueryCh).then(response => {
        this.listChildren = response.data.items
        this.listChildrenTotal = response.data.total
        this.FactoryList = response.data.factory
      })
    },
    handleCommand (command) {
      this.listQueryCh.factory_codes = command.items.factory_code
      this.ChangeFactory = command.items.factory_name
      this.OpenBusOrd(command.item, command.index, '2')
    },
    getUrl (str) {
      const reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
      const strValue = str.match(reg)
      if (strValue && strValue.length > 0) {
        return strValue[0]
      }
      return null
    },
    copyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy')
        if (success) {
          this.$message({ message: '复制成功', type: 'success' })
        } else {
          this.$message({ message: '复制失败', type: 'error' })
        }
      } catch (error) {
        this.$message({ message: error, type: 'error' })
      }
      document.body.removeChild(textarea)
    },
    changeComplete (state) {
      if (state === undefined) {
        this.listQuery.is_complete = null
      } else {
        this.listQuery.is_complete = state
      }
      this.listQuery.page = 1
      this.getBusinessOrdersList()
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
/*顶部滚动条*/
.top-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}
.top-scroll-content {
  background-color: #fff;
  height: 1px;
}
.num-y-color{
  color: #13ce66;
}
.num-n-color{
  color: #FF4948;
}
.cght_htmainright .liststyle span {
  float: right;
  width: 74px;
  height: 32px;
  background: #f8f8f8;
  font-size: 14px;
  line-height: 32px;
  border-radius: 3px;
  margin-left: 10px;
}
.cght_htmainright .liststyle span.bigtut a {
  background: url(../../assets/images/zp_46.png) no-repeat 14px center;
}
.cght_htmainright .liststyle span a {
  display: block;
  padding-left: 36px;
  color: #333;
}
.cght_htmainright .liststyle span.bigtut:hover,
.cght_htmainright .liststyle span.bigtut.on {
  background: #bcbcbc;
}
.cght_htmainright .liststyle span.bigtut:hover a,
.cght_htmainright .liststyle span.bigtut.on a {
  color: #fff;
  background: url(../../assets/images/zp_46_01.png) no-repeat 14px center;
}

.cght_htmainright .liststyle span.pricelass a {
  background: url(../../assets/images/zp_520.png) no-repeat 22px center;
}
.cght_htmainright .liststyle span.pricelass:hover,
.cght_htmainright .liststyle span.pricelass.on {
  background: #bcbcbc;
}
.cght_htmainright .liststyle span.pricelass:hover a,
.cght_htmainright .liststyle span.pricelass.on a {
  color: #fff;
  background: url(../../assets/images/zp_520_01.png) no-repeat 22px center;
}

.cght_htmainright .liststyle span.smalltut a {
  background: url(../../assets/images/zp_47.png) no-repeat 14px center;
}
.cght_htmainright .liststyle span.smalltut:hover,
.cght_htmainright .liststyle span.smalltut.on {
  background: #bcbcbc;
}
.cght_htmainright .liststyle span.smalltut:hover a,
.cght_htmainright .liststyle span.smalltut.on a {
  color: #fff;
  background: url(../../assets/images/zp_47_01.png) no-repeat 14px center;
}
.cght_ddtable_busord {
  margin-top: 15px;
}
.cght_ddtable_busord,.cght_ddtable_busord tr,.cght_ddtable_busord tr td {
  clear: both;
  border: 1px solid #e9e9e9;
}
.cght_ddtabletb_busord {
  background: #ecf5ff;
  height:38px;
}
.cght_ddtablesj_busord,.cght_ddtableddh_busord,.cght_ddtablesl_busord {
  float: left;
  line-height: 38px;
}
.cght_ddtableddh_busord {
  font-size: 14px;
  color: #999999;
}
.cght_ddtableddh_busord em {
  color: #999999;
}
.cght_ddtablesl_busord {
  width: 50px;
  font-size: 14px;
  text-align: center;
  color: #999999;
}
.cght_ddtablesc_busord {
  float: right;
  height: 38px;
  line-height: 38px;
  padding-right: 16px;
}
.cght_ddtablesc_busord i{
  font-size: 22px;
  color: #999999;
}
.cght_ddtablesc_busord i:hover{
  color: #409EFF;
  cursor: pointer;
}
.cght_ddtablesj_busord {
  font-size: 14px;
  color: #999999;
  padding-left: 12px; width:183px;
}
.cght_ddtablexxnrabox_busord {
  padding:20px 0px;
}
.cght_ddtablexxnra_busord {
  float: left;
  height: 82px;
  width: 82px;
  padding: 0px 10px 0px 23px;
}
.cght_ddtablexxnra_busord a {
  display: block;
  height: 80px;
  width: 80px;
  border: 1px solid #efefef;
}
.cght_ddtablexxnra_busord a:hover {
  border-color: #409EFF;
}
.cght_ddtablexxnrb_busord {
  width: 310px;
  float: left;
}
.cght_ddtablexxnrb_busord h2 {
  display: block;
  height: auto;
  line-height: 18px;
  font-size: 16px;
  color: #666666;
  font-weight: normal;
  overflow: hidden;
}
.cght_ddtablexxnrb_busord h2 a {
  color: #666666;
}
.cght_ddtablexxnrb_busord h2 a:hover {
  color: #409EFF;
}
.cght_ddtablexxnrb_busord h3 {
  display: block;
  height: auto;
  line-height: 18px;
  font-size: 15px;
  color: #666666;
  font-weight: normal;
  overflow: hidden;
  margin-top: 5px;
}
.cght_ddtablexxnrc_busord {
  width: 50px;
  height: 82px;
  line-height: 82px;
  text-align: center;
  float: left;
  font-size: 14px;
  color: #999999;
}
.cght_ddtableshrm_busord {
  text-align: center;
  font-size: 14px;
  color: #999999;
  word-break : break-all;
}
.set-content{
  max-height: 200px;
  overflow: hidden; /* 超出部分隐藏 */
}
.cght_ddtableje5_busord {
  text-align: center;
  font-size: 14px;
  color: #999999;
  padding-bottom: 4px;
  margin: 0px auto;
}
.cght_ddtablelast2_busord {
  height: 120px;
}
.cght_ddtablelast3_busord {
  text-align: center;
}
.set-popper{
  width: 300px;
  max-height: 300px;
  overflow: auto;
}
.set-popper::-webkit-scrollbar {/*滚动条整体样式*/
  width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.set-popper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 10px;
  background: #c1c1c1;
}
.set-popper::-webkit-scrollbar-track {/*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
.cght_cnxhtiwtjsp {
  height: 167px;
  width: 100%;
  padding-top: 175px;
}
.cght_cnxhtiwtjsp div {
  width: 144px;
  text-align: center;
  padding-left: 100px;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #959595;
  margin: 0px auto;
  clear: both;
}
.myemptydata {
  color:#959595;
}
.el-dropdown-link {
  cursor: pointer;
  color:#959595;
}
.cght_busorder {
  border-bottom: 2px solid #409EFF;
  color: #409EFF;
}
.cght_ddglnavula li a:hover {
  border-bottom: 2px solid #409EFF;
  color: #409EFF;
}
</style>
<style>
.noColor span {
  color: #fff;
  background-color: #E73939;
}
.el-form--label-top .el-form-item__label{
  padding-bottom: 0;
}
/* 设置自定义的选择器背景色和文本颜色 */
.custom-select-color .el-input .el-input__inner {
  /* 背景色 */
  /* background-color: #c0c0c0; */
  /* 边框色 */
  /* border-color: #c0c0c0; */
  /* 文本颜色 */
  color: #13ce66;
}
</style>



// WEBPACK FOOTER //
// src/view/member/business_orders.vue